import { render, staticRenderFns } from "./MediaCardHome.vue?vue&type=template&id=29bfdf15&scoped=true&"
import script from "./MediaCardHome.vue?vue&type=script&lang=js&"
export * from "./MediaCardHome.vue?vue&type=script&lang=js&"
import style0 from "./MediaCardHome.vue?vue&type=style&index=0&id=29bfdf15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bfdf15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VCard,VImg,VLazy})
